



















































import { Component, Prop, Vue } from 'vue-property-decorator'
import { AuthService as _authService } from '@/services/auth.service'
import { UserInfoDto } from '@/models/dtos/userInfoDto'
import router from '@/router'
import { EUserRole } from '@/models/dtos/enums/eUerRole'
import SidebarItems from '@/admin/components/SidebarItems.vue'

@Component(
  {
    components: {
      SidebarItems
    }
  }
)
export default class Sidebar extends Vue {
  // Data
  sidebarMobileVisibility: boolean = true;

  // Methods
  private toggleBodyScrollbar(visible: boolean) {
    const body = document.getElementsByTagName('body')[0]

    visible
      ? body.classList.add('overflow-hidden')
      : body.classList.remove('overflow-hidden')
  }
}
